const ADD_PLUGIN_LINK_BI = "addPluginLink";
const WEB_ADDRESS_CATEGORY = "web_address";
const ANCHOR_CATEGORY = "section";
const LINK_VIEWER_DATA_HOOK = "linkViewer";
const ANCHOR_VIEWER_DATA_HOOK = "anchorViewer";
const MEDIA_POPOVERS_BUTTONS_NAMES_BI = {
  embed: "ClickEmbed",
  upload: "ClickUpload",
  cancel: "ClickCancel"
};
const MEDIA_POPOVERS_TABS_NAMES_BI = { embed: "ClickEmbedTab", upload: "ClickUploadTab" };
const MAX_LIST_VISIBLE_INDENTATION = 4;

export { ADD_PLUGIN_LINK_BI, ANCHOR_CATEGORY, ANCHOR_VIEWER_DATA_HOOK, LINK_VIEWER_DATA_HOOK, MAX_LIST_VISIBLE_INDENTATION, MEDIA_POPOVERS_BUTTONS_NAMES_BI, MEDIA_POPOVERS_TABS_NAMES_BI, WEB_ADDRESS_CATEGORY };
//# sourceMappingURL=consts.js.map
